var React = require('react');

function StarEmpty (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#000","strokeLinejoin":"round","strokeWidth":"2","d":"m12.78 1.5 2.583 7.946h8.355l-6.76 4.911 2.582 7.947-6.76-4.911-6.759 4.91 2.582-7.946-6.76-4.91H10.2z"}));
}

StarEmpty.defaultProps = {"width":"25","height":"24","fill":"none","viewBox":"0 0 25 24"};

module.exports = StarEmpty;

StarEmpty.default = StarEmpty;
